// extracted by mini-css-extract-plugin
export default {"item":"DragAndDropItem_item__AYQW-"};